export default __webpack_public_path__ + "static/media/google.ff7be268.svg";